export default __webpack_public_path__ + "static/media/GPS_tracking_Filled_Active.956d7d70.svg";